const time = process.env.UPDATETIME
let a = '%c  Build Date ' + '%c ' + time + ' '
let b = 'color: #fadfa3; background: #030307; padding:5px 0;'
let c = 'background: #347eff; padding:5px 0;'
console.log(a, b, c)
